/**
 * No Fluff - Scroll reveal observer
 * Watches .nf-reveal elements and adds .nf-visible when they enter the viewport.
 */
(function () {
  var els = document.querySelectorAll('.nf-reveal');
  if (!els.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('nf-visible');
      }
    });
  }, { threshold: 0.15 });

  els.forEach(function (el) { observer.observe(el); });
})();
